import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import useIsMobile from "../../utils/useIsMobile";
import { BlueLinearGradient } from "../../utils/Utils";

export default function Testimonials() {
  const isMobile = useIsMobile(1030);
  const perRow = isMobile ? 1 : 2;
  const userTestimonials = [
    // {
    //   name: "Amit Gupta, Entrepreneur",
    //   testimonial:
    //     "I, being a thyroid patient, find it difficult to lose weight. I found getactyv a good and handy online platform for my daily exercise routine. Easy monitoring and performance tracking features have helped me to increase my metabolism rate.",
    //   city: "Bangalore",
    // },
    {
      name: "Ms. Arshia, Homemaker",
      testimonial:
        "On days when I don’t feel like doing any workout, going outside to the gym, or when the weather is dull and grumpy, getactyv comes as a saviour for my health. With its peppy music, aided GIF, animations, and guidance, I find it fun to stretch, do high cardio workouts and complete my daily goals of staying active and fit with their mixed workouts.",
      city: "Jaipur",
    },
    {
      name: "Advit, Student",
      testimonial:
        "I started doing workouts from getactyv for testing purposes and soon I realized that it's a lot of fun and liberating. Post covid, I couldn't continue my fitness routine but then thanks to getactyv, I filled those gaps now. For me, it is very handy as I can carry out different workouts anytime, anywhere without making it boring.",
      city: "California",
    },
    {
      name: "Mukesh Mansukhani, MNC C-suite",
      testimonial:
        "I have always wanted a solution that helped me focus on my fitness without worrying that my wrong will do more damage than help me in remaining fit. Then I case across getactyv.com which helps me get the right mix of exercises with expert that is watching me with full diligence and keeping my posture in check. Thanks getactyv team for this great product, keep up the good work.",
      city: "Hyderabad",
    },
    {
      name: "Shashank Johri, Multidisciplinary Designer",
      testimonial:
        "Training for running happens outside the running track. I was looking for a trainer who could help me perform exercises to improve my hour long, 3 days a week runs. With getactyv’s running fitness program, along with its pre and post run stretching routines, my runs have become smoother, pain free and more importantly enjoyable within a month’s time. I highly recommend getactyv, to anybody who wishes to perform workouts for a fulfilling running experience.  ",
      city: "Bangalore",
    },

    {
      name: "S.M. Gufran, Level ‘O’ coach",
      testimonial:
        "I was seeking for a robust fitness solution for my Academy players for a long time and I found that getactyv fits the best for us. The freedom of customizing programs and instant feedback is truly amazing. It is helping our players to take their fitness level up and  its easier for me to monitor their fitness through getactyv. It is futuristic!",
      city: "Bhopal",
    },

    {
      name: "Adarsh Asati, Senior software engineer",
      testimonial:
        "For me, the lack of time has been a major challenge for working out. There was always inconsistency in taking care of my health routine because of my packed schedule. For me Getactyv is like a magic stick. I am carrying my personal trainer and can workout anytime, anywhere. Highly recommended for people who don't have time to workout or find it difficult to go to the gym. I haven't seen such an advanced harmony of technology with fitness before.",
      city: "Pune",
    },

    {
      name: "Lakshaya Sharma, National Taekwondo player",
      testimonial:
        "I Always dedicate extra hours for strengthening my lower extremity. I am thrilled to see the exercise incorporated in HIIT and tabata programs on getactyv which are intense enough to take my strengthening above the bar. Also the ease of access and convenience to start my training anywhere, at any time is like the icing on the cake for me. ",
      city: "Delhi",
    },
    {
      name: "Naman Prajapati, Cricketer, Ranji Trophy Camp",
      testimonial:
        "For me fitness is the key to perform on the field. As a cricketer you need to  keep your fitness goals very specific, it is very difficult to get a way which caters all varieties of workout for your goals, but when i got to know about getactyv and started workout on it. I can see remarkable improvement in my fitness hence in my performance too. Now i don't need to be dependent on my trainer fully to set my fitness goals and recommend workouts, since getactyv fulfill my workout needs.",
      city: "Bhopal",
    },
  ];
  const [slideNumber, setSlideNumber] = useState(0);
  const intervalRef = useRef();
  const [viewRef, inView] = useInView();
  useEffect(() => {
    if (inView) {
      intervalRef.current = setInterval(() => {
        setSlideNumber((prevState) => {
          return (prevState + 1) % Math.ceil(userTestimonials.length / perRow);
        });
      }, 10000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  }, [inView]);

  const updateTestimonialInView = (changeBy) => {
    setSlideNumber((prevState) => {
      return prevState == 0 && changeBy == -1
        ? Math.ceil(userTestimonials.length / perRow) - 1
        : (prevState + changeBy) % Math.ceil(userTestimonials.length / perRow);
    });
  };

  return (
    <div className="" ref={viewRef}>
      <div className="h-full 2xl:h-full flex flex-row gap-1 justify-center items-center w-full mt-5">
        <div
          className={`Flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
          onClick={() => {
            updateTestimonialInView(-1);
          }}
        >
          <Icon
            icon="fluent:arrow-next-12-filled"
            className="text-primary-white h-auto w-5 rotate-180"
          />
        </div>
        {Array.from(
          { length: Math.ceil(userTestimonials.length / perRow) },
          (_, i) => {
            if (slideNumber != i) return <></>;
            return (
              <div
                className={`grid grid-cols-${perRow} gap-28 transition ease-in animate-slide-left-to-right`}
              >
                {userTestimonials
                  .slice(i * perRow, (i + 1) * perRow)
                  .map((userTestimonial) => {
                    return (
                      <div className="flex flex-col col-span-1">
                        <p className="font-poppins font-bold text-4xl text-primary-neonGreen">
                          “
                        </p>
                        <p className="md:text-lg leading-7 md:leading-9 px-4 text-white text-opacity-80 font-open-sans">
                          {userTestimonial.testimonial}
                        </p>
                        <p className="text-xl md:text-2xl px-4 mt-9 font-bold text-white text-opacity-80 font-open-sans">
                          {userTestimonial.name}
                        </p>
                        <p className="text-lg px-4 text-white text-opacity-80 font-open-sans">
                          {userTestimonial.city}
                        </p>
                      </div>
                    );
                  })}
              </div>
            );
          }
        )}
        <div
          className={` flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 right-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
          onClick={() => {
            updateTestimonialInView(1);
          }}
        >
          <Icon
            icon="fluent:arrow-next-12-filled"
            className="text-primary-white h-auto w-5"
          />
        </div>
      </div>
      <div className="flex flex-row gap-1 justify-center items-center w-full mt-5">
        {Array.from(
          { length: Math.ceil(userTestimonials.length / perRow) },
          (_, i) => {
            return (
              <div
                className={`h-2 ${
                  slideNumber == i
                    ? "w-4 bg-primary-neonGreen"
                    : "w-2 bg-black-400 bg-opacity-80"
                } rounded-full`}
              ></div>
            );
          }
        )}
      </div>
    </div>
  );
}
